import { Autocomplete, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import DefaultInput from "../../../../../../common/components/default_input";
import { DefaultDatePicker } from "../../../../../../common/components/masked_inputs/default_date_picker_input";
import { DropDownNomeAuditor } from "../../../../../../common/components/dropdown_nome_auditor";
import { DefaultNomeAuditor } from "../../../../../../common/components/default_nome_auditor";
import { DefaultDataAuditoria } from "../../../../../../common/components/default_data_auditoria";
import { DefaultFornecedor } from "../../../../../../common/components/default_fornecedor_select";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";
import { DefaultProduto } from "../../../../../../common/components/default_produtor_select";
import { DefaultFuncioanrio } from "../../../../../../common/components/default_funcionarios.select";

// Header 

type Props = {
  pesquisa: string | null,
  centroDeCustoLista: { id: number; title: string }[];
  centroDeCustoSaida: number[];
  centroDeCustoDestino: number[];
  FuncionarioPesquisa: number;
  ProdutorPesquisa: number;
  dataSaidaDe: Date | null;
  dataSaidaAte: Date | null;
  onClearFilters: () => void;
  handleCentroDeCustoSaida: (v: number[]) => void;
  handleCentroDeCustoDestino: (v: number[]) => void;
  handleFuncionarioChange: (v: number) => void;
  handleProdutorChange: (v: number) => void;
  handleDataEntradaRangeChange: (v: Date | null, x: Date | null) => void;
  handlePesquisa: (v: string | null) => void,
};


export const Header = ({ centroDeCustoSaida, centroDeCustoDestino, centroDeCustoLista, pesquisa, FuncionarioPesquisa, dataSaidaAte, dataSaidaDe, ProdutorPesquisa, handleProdutorChange, handleDataEntradaRangeChange, handleFuncionarioChange, handleCentroDeCustoSaida, handleCentroDeCustoDestino, onClearFilters, handlePesquisa }: Props) => {
  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);
  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full flex flex-col gap-6">
        <div className="w-full grid gap-4 grid-cols-1 md:grid-cols-2">
          <FormControl size="small" fullWidth>
            <Autocomplete
              size="small"
              multiple
              options={centroDeCustoLista}
              value={centroDeCustoLista.filter((i) => centroDeCustoSaida.includes(i.id))}
              getOptionLabel={(i) => i.title}
              onChange={(_, newValue) => {
                handleCentroDeCustoSaida(newValue.map((i) => i.id));
              }}
              isOptionEqualToValue={(opt, val) => opt.id === val.id}
              renderInput={(params) => (
                <TextField {...params} size="small" label="Centro de Saída" />
              )}
            />
          </FormControl>
          <FormControl size="small" fullWidth>
            <Autocomplete
              size="small"
              multiple
              options={centroDeCustoLista}
              value={centroDeCustoLista.filter((i) => centroDeCustoDestino.includes(i.id))}
              getOptionLabel={(i) => i.title}
              onChange={(_, newValue) => {
                handleCentroDeCustoDestino(newValue.map((i) => i.id));
              }}
              isOptionEqualToValue={(opt, val) => opt.id === val.id}
              renderInput={(params) => (
                <TextField {...params} size="small" label="Centro de Destino" />
              )}
            />
          </FormControl>

          <div className="w-full">
            <DefaultFuncioanrio
              key={`func-${FuncionarioPesquisa}`}
              name="PesquisarSolicitante"
              value={FuncionarioPesquisa || null}
              onChange={(valor) => handleFuncionarioChange(Number(valor))}
              label="Solicitante"
            />
          </div>

          {/* 3. Produto */}
          <div className="w-full">
            <DefaultProduto
              key={`prod-${ProdutorPesquisa}`}
              name="PesquisarProdutor"
              value={ProdutorPesquisa || null}
              onChange={(valor) => handleProdutorChange(Number(valor))}
              label="Produto"
              tipo="P"
              incluirCodigoDescricao={true}
            />
          </div>

          {/* 4. Data de Saida */}
          <div className="w-full">
            <DefaultDateRangePickerInput
              label='Data de Saída'
              dataDe={dataSaidaDe ?? null}
              dataAte={dataSaidaAte ?? null}
              onChange={async (start, end) => {
                handleDataEntradaRangeChange(start, end)
              }}
            />
          </div>

          {/* 5. Nota Fiscal */}
          <div className="w-full">
            <DefaultInput
              label="Nota Fiscal"
              name="search_by_name"
              value={typeof pesquisa === 'string' ? pesquisa : ''}
              onChangeValue={handlePesquisa}
            />
          </div>

          {/* Botão de Limpar (Ocupa as duas colunas na última linha e alinha à direita) */}
          <div className="w-full flex justify-end md:col-span-2 mt-2">
            <div className="w-full md:w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={handleClearFilters}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>

        </div>
      </div>
    </CascateList>
  );
}